import { useCallback } from 'react'
import { AxiosRequestConfig } from 'axios'
import { useHttpClientConfig } from '../../useHttpClientConfig'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { CustomerProfile, CustomerProfileRequest } from '../../../types/customerProfileService'
import { makeGetCustomerProfile } from './customerProfile'

interface CustomerProfileService {
  getCustomerProfile: (request: CustomerProfileRequest) => Promise<CustomerProfile>
  isReady: boolean
}

const useCustomerProfileService = (): CustomerProfileService => {
  const { config } = useHttpClientConfig()
  const { url } = useServiceCountryUrl('customerProfile')
  const baseUrl = url.href

  const getCustomerProfile = useCallback(makeGetCustomerProfile(baseUrl, config as AxiosRequestConfig), [config, baseUrl])

  return {
    getCustomerProfile,
    isReady: Boolean(config),
  }
}

export { useCustomerProfileService }
